
import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import columnTitleAnimations from './elemental/columnTitle'
import multiColumnAnimations from './elemental/multiCol'
import simpleSliderAnimations from './elemental/simpleSlider'
import videoAnimations from './elemental/video'
import wysiwygAnimations from './elemental/wysiwyg'
import statisticAnimations from './elemental/statistic'
import iconBlockAnimations from './elemental/iconBlock'
import profileCardAnimations from './elemental/profileCard'

gsap.registerPlugin(ScrollToPlugin)

window.addEventListener('frame-ready', init)

function init() {
    const sections = Array.from(document.querySelectorAll('.elemental-section'))

    if(sections.length > 0) {
        sections.forEach(section => {
            columnTitleAnimations(section)
            multiColumnAnimations(section)
            simpleSliderAnimations(section)
            videoAnimations(section)
            wysiwygAnimations(section)
            statisticAnimations(section)
            iconBlockAnimations(section)
            profileCardAnimations(section)
        })
    }
}
